import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { addMinutes } from "date-fns/addMinutes";
import { startOfDay } from "date-fns/startOfDay";
import { getEventCellColorsFromHex } from "../../utils";
import { useDateFnsFormattersWithLocale } from "@tellescope/ui";

export interface MonthViewDragOverlayProps {
  event: TellescopeModelFromName<"calendar_events">;
  hoveredDayStart: number | null;
  timezone?: string;
}

export const MonthViewDragOverlay = ({
  event,
  hoveredDayStart,
  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: MonthViewDragOverlayProps) => {
  const { formatInTimeZone } = useDateFnsFormattersWithLocale();
  const eventStartDay = startOfDay(new Date(event.startTimeInMS)).getTime();
  const dayDeltaMs = (hoveredDayStart ?? eventStartDay) - eventStartDay;
  const newStart = new Date(event.startTimeInMS + dayDeltaMs);
  const durationInMinutes = event.actualDuration ?? event.durationInMinutes;
  const newEnd = addMinutes(newStart, durationInMinutes);
  const isMultiDay = startOfDay(newStart).getTime() !== startOfDay(newEnd).getTime();

  const { backgroundColor, borderColor, textColor } = getEventCellColorsFromHex(event.color);

  return (
    <div
      className="rounded-sm border px-2 py-1 text-xs shadow-lg flex flex-col gap-0.5 max-w-[280px]"
      style={{ backgroundColor, borderColor, color: textColor }}
    >
      <span className="font-semibold truncate">{event.displayTitle || event.title}</span>
      <span className="text-[10px]">
        {formatInTimeZone(newStart, timezone, "MMM d")}
        {isMultiDay && ` – ${formatInTimeZone(newEnd, timezone, "MMM d")}`}
      </span>
    </div>
  );
};
